const integerFormat = Intl.NumberFormat("fi-FI", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const decimalFormat = Intl.NumberFormat("fi-FI", {
  style: "currency",
  currency: "EUR",
});

export { integerFormat, decimalFormat };
